import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Integrationsetting } from '@src/app/models/integrationsetting';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsettingsService {

  constructor(private http:HttpClient) { }

  private getHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    };
  }
        
   getIntegrationsettings(){
     return this.http.get<Integrationsetting>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/integrationsetting", this.getHttpOptions());
   }
   setIntegrationsettings(integrationsetting:Integrationsetting){
    //console.log('set',integrationsetting);
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/integrationsetting',JSON.stringify(integrationsetting), this.getHttpOptions());
  }

  sendTestEmail(payload: any){
    return this.http.post<any>(
      environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/integrationsetting/test-email',
      JSON.stringify(payload),
      this.getHttpOptions()
    );
  }
}
